// src/components/OrderEntry/utils/directShipRules.js
// =============================================================================
// DIRECT SHIP PATIENT WORKFLOW RULES
// =============================================================================

// -----------------------------------------------------------------------------
// BLOCK OEDSR.TYPE.0 — Identify the TMS ShipToCode P direct-ship mode
// -----------------------------------------------------------------------------
export function isTmsPatientShipTo(company, shipToCode) {
  return (
    String(company ?? '')
      .trim()
      .toLowerCase() === 'tms' &&
    String(shipToCode ?? '')
      .trim()
      .toUpperCase() === 'P'
  );
}

const normalizeShipToCodeForSugar = (value, { company } = {}) => {
  const raw = String(value ?? '').trim();
  if (!raw) {
    return '';
  }

  if (raw.toUpperCase() === 'P') {
    return 'P';
  }

  if (
    String(company ?? '')
      .trim()
      .toUpperCase() === 'TMS' &&
    /^\d+$/.test(raw)
  ) {
    return raw.padStart(2, '0');
  }

  return raw.toUpperCase();
};

// -----------------------------------------------------------------------------
// BLOCK OEDSR.SUGAR.0 — Sugar account lookup ShipToCode override
// -----------------------------------------------------------------------------
// Rule:
// - When TMS direct-ship patient mode is active, Sugar lookup should prefer the
//   highlighted street-address ShipToCode (selected row) instead of forcing 1.
// - If selected-row ShipToCode is unavailable, fallback remains 1.
// -----------------------------------------------------------------------------
export function resolveSugarLookupShipToCode(company, shipToCode, selectedAddressShipToCode = '') {
  if (!isTmsPatientShipTo(company, shipToCode)) {
    return normalizeShipToCodeForSugar(shipToCode, { company });
  }

  const selectedShipTo = normalizeShipToCodeForSugar(selectedAddressShipToCode, { company });

  if (selectedShipTo) {
    return selectedShipTo;
  }

  return '1';
}

// -----------------------------------------------------------------------------
// BLOCK OEDSR.FRT.0 — Freight defaults for TMS direct-ship patient mode
// -----------------------------------------------------------------------------
export function getDirectShipFreightDefaults(company, shipToCode) {
  if (!isTmsPatientShipTo(company, shipToCode)) {
    return null;
  }

  return {
    carrier: 'USPS',
    shipVia: 'USPSG',
    frtPay: 'Free',
  };
}
